<template>
  <div class="vuestic-widget preview-widget">
    <div class="vuestic-widget-header justify--center" v-bind:style="{ backgroundColor: confirmedBackgroundColor(trip) }">
      <div class="center" style="font-weight:200" v-bind:style="{ color: confirmedColor(trip) }">{{confirmedText(trip)}}</div>
      <div class="vuestic-icon">
        <span
          aria-hidden="true"
          class="edit-icon glyphicon ml-3"
          @click="$router.push(`trip/edit/${trip.id}`)"
        ></span>
      </div>
    </div>
    <div class="vuestic-widget-body">
      <div class="va-row justify--center">
        <!-- <div class="flex xs1 pr-0">{{$t('general.price')}}:</div> -->
        <div class="flex md-4 pl-0 bold">{{ trip.title }}</div>
      </div>
      <div class="va-row justify--center">
        <!-- <div class="flex xs1 pr-0">{{$t('preview.dates')}}:</div> -->
        <div class="flex md-4 pl-0">{{ this.getDataRange() }}</div>
      </div>
      <div class="va-row justify--center">
        <div class="flex pr-1 text-capitalize">{{$t('general.price')}}:</div>
        <div class="flex md-4 pl-0">{{ toCurrency(trip.price) }}</div>
      </div>
      <div class="va-row justify--center">
        <div class="flex pr-1 text-capitalize">{{$t('general.deposit')}}:</div>
        <div class="flex md-4 pl-0">{{ toCurrency(trip.deposit) }}</div>
      </div>
      <div class="va-row justify--center">
        <div class="flex pr-1">{{$t('preview.enlisted')}}:</div>
        <div class="flex md-4 pl-0">{{ trip.members }}</div>
        <div
          class="flex md-4 pl-0"
        >{{ $t('preview.totalParticipants',{number: trip.participants}) }}</div>
      </div>
      <div class="va-row justify--center">
        <div class="flex pr-1 link tripDetails" :class="{ visible : !!trip.tripDetails }"
          @click="showSchedule()" style="cursor:pointer">
            <span aria-hidden="true" class="fa fa-file-word-o" style="font-size: 22px;"></span>
          {{ $t("preview.schedule")}}
          </div>
      </div>
      <div class="va-row justify--center">
        <div class="flex pr-1">{{$t('preview.status')}}:</div>
        <div class="flex md-4 pl-0 bold"
        v-bind:style="{ color: statusColor(trip.status) }">{{ statusLabel(trip.status) }}</div>
      </div>
      <div class="va-row justify--space-around">
        <button
          class="btn btn-secondary btn-micro flex md4 xs4"
          @click="$router.push(`add-traveller?tripId=${trip.id}`)"
        >{{ $t("preview.addTraveler")}}</button>
        <button
          class="btn btn-secondary btn-micro flex md4 xs3"
          @click="$router.push(`trip/details/${trip.id}`)"
        >{{ $t("preview.moreInfo")}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { tripApi } from "../../services/api/tripApi";
import { getIfNotNull, formatCurrency, openFileInNewTab } from "../../utils";
import { host } from "../../services/http";

export default {
  name: "trip-preview",
  props: {
    trip: Object
  },
  mounted: function() {},
  data() {
    return {
      title: "",
      price: "",
      participants: ""
    };
  },

  methods: {
    timeConverter(timestamp) {
      var a = new Date(timestamp * 1000);
      var months = [
        this.$t("months.short.1"),
        this.$t("months.short.2"),
        this.$t("months.short.3"),
        this.$t("months.short.4"),
        this.$t("months.short.5"),
        this.$t("months.short.6"),
        this.$t("months.short.7"),
        this.$t("months.short.8"),
        this.$t("months.short.9"),
        this.$t("months.short.10"),
        this.$t("months.short.11"),
        this.$t("months.short.12")
      ];
      var year = a.getFullYear();
      var month = months[a.getMonth()];
      var date = a.getDate();
      var time = { date, month, year };
      return time;
    },
    getDataRange(startTimestap, endTimestamp) {
      const startDate = this.timeConverter(this.trip.startDate);
      const endDate = this.timeConverter(this.trip.endDate);
      return `${startDate.date} ${startDate.month} ${
        startDate.year == endDate.year ? "" : startDate.year
      } - 
        ${endDate.date} ${endDate.month} ${endDate.year}`;
    },
    confirmedText(trip) {
      if (!trip) return "";
      if (trip.enrolled >= trip.minimumParticipants) {
        return "Потвърдено";
      }
      return "Непотвърдено";
    },
    confirmedColor(trip) {
      if (!trip) return "";
      if (trip.enrolled >= trip.minimumParticipants) {
        return "#76eaa4"
      }
      return "grey"
    },
    confirmedBackgroundColor(trip) {
      if (!trip) return "";
      if (trip.enrolled >= trip.minimumParticipants) {
        return "#E3FAEC"
      }
      return "#ffffff"
    },
    statusLabel(status) {
        let statuses = ["", "Активно", "Проведено", "Непроведено"]
        return statuses[status];
    },
    statusColor(status) {
        let statuses = ["", "#ffd500", "grey", "#ff4500"]
        return statuses[status];
    },
    toCurrency(price) {
      return formatCurrency(price, this.$i18n.locale());
    },
    showSchedule() {
      tripApi
        .getDocument(this.trip.id, this.trip.tripDetails)
        .then(url => {
          const link = document.createElement("a");
          link.href = `${host}${url}`;
          link.setAttribute("download", "file.docx");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => console.log(`Error: ${e}`));
    }
  }
};
</script>

<style lang="scss">
.preview-widget {
  .vuestic-widget-body {
    font-size: 1.345rem;
  }

  .edit-icon {
    width: 22px;
    height: 22px;
    font-size: 22px;
    cursor: pointer;
  }

  &:hover .edit-icon::before {
    content: "\270F";
  }

  .tripDetails{
    visibility: hidden;
  }

  .center {
    text-align: center;
  }
  
}
</style>
